import { useEffect, useState } from "react";
import BackButton from "../../../components/BackButton";
import AdminStoryCard from "../../../components/AdminStoryCard";
import Loader from "../../../layout/Loader";
import axios from "axios";
import { Link } from "react-router-dom";

const AllStories = () => {

    const [stories, setStories] = useState(null);

    useEffect(() => {
        async function getStories() {
            try {
                const res = await axios(`https://api.sleepingwithwho.com/api/admin/stories`,{
                    headers: {
                         'Content-Type': 'application/json',
                         'Authorization' : 'Bearer '+localStorage.getItem('token')
                         }
                })
                setStories(res.data)
            } catch (error) {
                console.error('Error fetching data', error);
            }
        };

        getStories();
    }, []);


    if (!stories) {
        return <Loader />
    }

    return (
        <div className='container mt-4'>
            <h2 className='text-success'>Stories</h2>
            <p>Tap in some juicy wet stories from real life situations</p>
            <BackButton location={"/admin/dashboard"} />
            <Link to="/admin/stories/create" className="m-3">Create story</Link>

            <div className="story-list">
                {
                    stories && stories.map((story) => <AdminStoryCard key={story.id} story={story} />)
                }
            </div>
        </div>
    )
}

export default AllStories